<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de direcciones</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/address+c" (click)="createAddress()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncAddress | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let address">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/address+u"
                    (click)="updateAddress(address)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/address" (click)="eliminate(address)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let address">
                {{ address.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="street">
              <th mat-header-cell *matHeaderCellDef>Vereda/Barrio</th>
              <td mat-cell *matCellDef="let address">
                {{ address.street }}
              </td>
            </ng-container>

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>Número</th>
              <td mat-cell *matCellDef="let address">
                {{ address.number }}
              </td>
            </ng-container>

            <ng-container matColumnDef="complement">
              <th mat-header-cell *matHeaderCellDef>Complemento</th>
              <td mat-cell *matCellDef="let address">
                {{ address.complement }}
              </td>
            </ng-container>
            <ng-container matColumnDef="territory">
              <th mat-header-cell *matHeaderCellDef>Territorio</th>
              <td mat-cell *matCellDef="let address">
                {{ address.territory }}
              </td>
            </ng-container>
            <ng-container matColumnDef="authority">
              <th mat-header-cell *matHeaderCellDef>Autoridad</th>
              <td mat-cell *matCellDef="let address">
                {{ address.authority }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchAddress($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
